import { useState, useEffect, useCallback } from 'react';
import { auditAPI, authAPI, wassengerAPI } from '../../services/api';
import ChangeRow from './ChangeRow';

const RANGES = [
  { id: '24h', label: 'Últimas 24h' },
  { id: '7d', label: 'Últimos 7 días' },
  { id: '30d', label: 'Últimos 30 días' },
];

export default function ChangeHistoryView({ onNavigateToContact }) {
  const [range, setRange] = useState('24h');
  const [order, setOrder] = useState('desc');
  const [agent, setAgent] = useState(null);
  const [includeBot, setIncludeBot] = useState(false);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [team, setTeam] = useState([]);
  const currentUser = authAPI.getCurrentUser();
  const isAdmin = !!currentUser?.is_admin;

  useEffect(() => {
    if (!isAdmin) return;
    wassengerAPI.getTeam().then(t => setTeam(Array.isArray(t) ? t : [])).catch(() => {});
  }, [isAdmin]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await auditAPI.getChanges({ range, order, agent, include_bot: includeBot });
      setGroups(r.groups || []);
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Error cargando historial');
    } finally {
      setLoading(false);
    }
  }, [range, order, agent, includeBot]);

  useEffect(() => { fetchData(); }, [fetchData]);

  return (
    <div className="p-4">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        {RANGES.map(r => (
          <button
            key={r.id}
            onClick={() => setRange(r.id)}
            className={`px-3 py-1 rounded-full text-base font-semibold transition ${
              range === r.id
                ? 'bg-indigo-600 text-white shadow'
                : 'bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-slate-600'
            }`}
          >{r.label}</button>
        ))}
        <button
          onClick={() => setOrder(order === 'desc' ? 'asc' : 'desc')}
          className="px-3 py-1 rounded-full text-base bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-slate-600"
          title="Invertir orden"
        >
          {order === 'desc' ? '▼ Reciente primero' : '▲ Antiguo primero'}
        </button>
        {isAdmin && team.length > 0 && (
          <select
            value={agent || ''}
            onChange={e => setAgent(e.target.value || null)}
            className="px-3 py-1 rounded-full text-base bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300 border-0"
          >
            <option value="">Todos los agentes</option>
            {team.map(t => (
              <option key={t.id} value={t.displayName}>{t.displayName}</option>
            ))}
          </select>
        )}
        <label className="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400 ml-2 cursor-pointer">
          <input type="checkbox" checked={includeBot} onChange={e => setIncludeBot(e.target.checked)} />
          Incluir bot/Sistema
        </label>
        <button
          onClick={fetchData}
          className="ml-auto px-3 py-1 rounded text-sm bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-slate-600"
          title="Refrescar"
        >🔄</button>
      </div>

      {loading && <div className="text-center py-8 text-base text-gray-500 dark:text-gray-400">Cargando...</div>}
      {error && <div className="bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 p-3 rounded text-base">{error}</div>}
      {!loading && !error && groups.length === 0 && (
        <div className="text-center py-12 text-gray-500 dark:text-gray-400">
          <div className="text-xl mb-2">Sin cambios en este período</div>
          <div className="text-sm">El historial es nuevo: solo notas y ventas tienen datos previos al deploy.</div>
        </div>
      )}
      {!loading && groups.map(g => (
        <ChangeRow key={g.contact_id} group={g} onContactClick={onNavigateToContact} />
      ))}
    </div>
  );
}
